import { Accordion } from '@farol-ds/react'

import { ComparePlansTable, tableData } from '../../../compare-plans-table'
import { DATA_TESTID } from '../../constants'
import styles from '../juris-three-offers-switch-frequency-lock-content.module.scss'

type ComparePlansAccordionProps = {
  onValueChange: (value: string) => void
}

export function ComparePlansAccordion({ onValueChange }: ComparePlansAccordionProps) {
  return (
    <Accordion
      collapsible
      size="lg"
      type="single"
      data-testid={DATA_TESTID.COMPARE_PLANS_ACCORDION}
      onValueChange={onValueChange}
    >
      <Accordion.Item value="1">
        <Accordion.Header>
          <Accordion.Title>Compare os planos</Accordion.Title>
        </Accordion.Header>

        <Accordion.Content forceMount asChild>
          <div className={styles.jurisThreeOffersSwitchFrequencyContentAccordionTable}>
            <ComparePlansTable plans={tableData.plans} benefits={tableData.benefits} />
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
